module.exports = __webpack_public_path__ + "static/media/login-register-bg.164cafd0.png";